module.exports = __webpack_public_path__ + "img/Planificado.3dd338dd.svg";